import "./Tabsv2.scss";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { withTranslation, useTranslation, Trans } from "react-i18next";
import {
  Link
} from "react-router-dom";

const SimpleTabsv2 = ({ handleChange , title , value }) => {
const { t } = useTranslation();

  return (
    <div className="simpleTabsv2 d-lg-block d-none py-md-4 py-2">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-3 d-flex flex-column justify-content-center">
            <div className="row main_area_heading mr-auto mx-3">
              <h4  className="text-uppercase d-flex text-center mb-0"> <strong>{title}</strong></h4>
            </div>

          </div>
          <div className="col-sm-9 d-lg-block d-none tabNavigationParentv2">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              aria-label="scrollable force tabs example"
            >

              <Tab
                label={t("dashboard.transactions")}
                component={Link}
                to={`/dashboard/transactions`}
              />
               <Tab
                label={t("dashboard.orders")}
                component={Link}
                to={`/dashboard/orders`}
              />
              <Tab
                label={t("dashboard.promocodes")}
                component={Link}
                to={`/dashboard/promo`}
              />
              <Tab
                label={t("dashboard.rewards")}
                component={Link}
                to={`/dashboard/rewards`}
              />
              <Tab
                label={t("dashboard.my-profile")}
                component={Link}
                to={`/dashboard/profile`}
              />
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(SimpleTabsv2);
